import React, { useContext } from "react";
import { PLACEHOLDER_MOVIE_POSTER } from "@config/ImageSizes";
import { ApplicationContext } from "@context/ApplicationContext";
import { AuthContext } from "@context/AuthContext";
import Loader from "@components/Ui/Loader";
import MovieSlider from "@components/V3/MoviesSlider";

const ComingSoon = () => {
    const { comingSoon, isMoviesLoading } = useContext(AuthContext);
    const { cdnUrl } = useContext(ApplicationContext);
    const fallbackImage = `${cdnUrl}${PLACEHOLDER_MOVIE_POSTER}`;

    if (isMoviesLoading) {
        return <Loader isLoading={true} text="Fetching Movies" />;
    }

    if (!comingSoon || !Array.isArray(comingSoon) || comingSoon.length === 0) {
        return (
            <p className="paragraph">There are no upcoming movies.</p>
        );
    }

    return (
        <MovieSlider
            title="Coming Soon"
            movies={comingSoon}
            isLoading={isMoviesLoading}
            fallbackImage={fallbackImage}
            baseClass="movie-slider"
            getMovieId={(m) => m.id}
            getMovieTitle={(m) => m.title}
            getMovieImage={(m) => m?.movie_image?.[0]?.local_url}
        />
    );
};

export default ComingSoon;
